import { implementCustomExpressions } from '../__generated/implementation.js';
import { FenixVariant, Legs3D, LegsAxel, LegsBrago, LegsButterfly, LegsClassico, LegsDiamond, LegsEbonu3DoubleEik, LegsEbonu3DoubleStaal, LegsEbonuEik, LegsEbonuStaal, LegsEbu, LegsElmoDouble, LegsFalke, LegsFly, LegsHarper, LegsLivio, LegsLivioSchuinEik, LegsLivioSchuinStaal, LegsMPootRecht, LegsMPootSchuin, LegsNovaroDoubleEik, LegsNovaroDoubleStaal, LegsOxford, LegsPapillon, LegsPapillonStrak, LegsRafino, LegsRobuDoubleEik, LegsRobuDoubleStaal, LegsTPoot, LegsTPootRonde, LegsTrapezium, LegsTwist4, LegsUPoot, LegsXPoot } from '../__generated/model/index.js';
// Exported because Danish Oval, Half Circle and Half Oval are the same
export const AVAILABLE_LEG_TYPES_RECTANGLE = [
    Legs3D.type,
    LegsAxel.type,
    LegsBrago.type,
    LegsButterfly.type,
    LegsClassico.type,
    LegsDiamond.type,
    LegsEbonuEik.type,
    LegsEbonuStaal.type,
    LegsEbonu3DoubleEik.type,
    LegsEbonu3DoubleStaal.type,
    LegsEbu.type,
    LegsElmoDouble.type,
    LegsFalke.type,
    LegsFly.type,
    LegsHarper.type,
    LegsLivio.type,
    LegsLivioSchuinEik.type,
    LegsLivioSchuinStaal.type,
    LegsMPootRecht.type,
    LegsMPootSchuin.type,
    LegsNovaroDoubleEik.type,
    LegsNovaroDoubleStaal.type,
    LegsOxford.type,
    LegsPapillon.type,
    LegsPapillonStrak.type,
    LegsRafino.type,
    LegsRobuDoubleEik.type,
    LegsRobuDoubleStaal.type,
    LegsTPoot.type,
    LegsTPootRonde.type,
    LegsTrapezium.type,
    LegsTwist4.type,
    LegsUPoot.type,
    LegsXPoot.type
];
export const topRectangleExpressions = implementCustomExpressions({
    TopRectangle: {
        $objectName: (self)=>self.fenixVariant === FenixVariant.Birch ? 'FENIX_RECHTHOEK_RECTANGLE' : 'RECHTHOEK_RECTANGLE',
        $availableLegTypes: ()=>AVAILABLE_LEG_TYPES_RECTANGLE
    }
});

//# sourceMappingURL=top-rectangle.js.map